export default {"src":"/_next/static/media/app-lineapp.ba8c14d5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};